import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ImageSelectionModalComponent } from './image-selection-modal.component';
import { EditSocialCardComponent } from 'src/app/components/edit-social-card/edit-social-card.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    ImageSelectionModalComponent
  ],
  imports: [
    IonicModule,
    FormsModule,
    CommonModule,
    EditSocialCardComponent,
  ],
})
export class ImageSelectionModule {

}
